<template>
    <transition name="modal">
        <div id="addTalkgroupToUser" class="dialog-modal-mask">
            <div class="large-panel" @click.stop>
                <div class="dialog-title">
                    <div v-if="editTagList.size==0" v-t="'message.action_add_group_to_user'">
                    </div>
                    <div v-else v-t="'message.action_edit_group_of_user'">
                    </div>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-body">
                    <table width=100% height=100% cellpadding=0 cellspacing=0>
                        <tr class="dialoginputfield">
                            <td colspan=2>
                                <div style="padding: 10px;">
                                    <el-form @submit.native.prevent="findGroup()">
                                        <el-radio-group style="padding-left:10px" v-model="listType" fill="#5171cb">
                                            <el-radio-button :label="0"><span v-t="'message.action_select_by_list'"/></el-radio-button>
                                            <el-radio-button :label="1"><span v-t="'message.action_select_by_search'"/></el-radio-button>
                                        </el-radio-group>
                                        <el-input v-if="listType == 1" :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" clearable class="object-search-select">
                                            <el-select v-model="condition" slot="prepend" :placeholder="$t('message.place_holder_search_condition')" class="search-item">
                                                <el-option :label="$t('message.item_groupId')" value="groupId"></el-option>
                                                <el-option :label="$t('message.item_groupDisplayName')" value="groupName"></el-option>
                                            </el-select>
                                            <el-button slot="append" style="width: 100px;vertical-align:middle" native-type="submit" v-t="'message.action_search_items'"></el-button>
                                        </el-input>
                                    </el-form>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_select_group'">
                                        </div>
                                        <div v-if="listType == 1" class="inner-panel-title-right">
                                            <button class="transparent" @click="selectTagAll()" type="button"><span class="normal-command-text" v-t="'message.action_select_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="listType == 0" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <dialogtree
                                        v-bind:initialData="tenantList"
                                        @on-selectnode="handleOnSelectNode"
                                        selectionType=2
                                        ref="dialogTree">
                                    </dialogtree>
                                </div>
                                <div v-else class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div class="foundObject-record" v-for="object in foundGroupList" @click="addUserTag(object.node.data)">
                                        <div class="foundObject">
                                            <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td class="dialog-td">
                                <div class="inner-panel-header">
                                    <div class="inner-panel-title">
                                        <div class="inner-panel-title-left" v-t="'message.title_editing_group'">
                                        </div>
                                        <div class="inner-panel-title-right">
                                            <button class="transparent" @click="removeAllUserTag()" type="button"><span class="normal-command-text" v-t="'message.action_delete_all'"></span></button>
                                        </div>
                                    </div>
                                </div>
                                <div id="selected-user" class="inner-panel-dialog" style="height: calc(80vh - 250px);">
                                    <div class="selected-item-field">
                                        <div class="default-message" v-if="Object.keys(editTagList) == 0" v-html="$t('message.hint_add_group_to_user')">
                                        </div>
                                        <span v-for="tag in editTagList" v-bind:key="tag.id">
                                            <div class="userTag">
                                                <span>{{ tag.displayName }}</span>
                                                <span class="closeTag" @click="removeUserTag(tag)">×</span>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')" v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="this.disableSave" @click="saveUpdatedInfo()" v-t="'message.button_save'"></el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import DialogTree from "./DialogTree.vue"
import commonUtil from './commonutil.js';
import constants from './constants.js';

const STATUS_SUCCESS = 0;
const STATUS_ALREADY_EXIST = -1;
const STATUS_UNMATCH_SPEECH_TO_TEXT = -2;
const STATUS_UNMATCH_TRANSLATION = -3;
const STATUS_UNMATCH_MAPTALK = -4;
const STATUS_UNMATCH_VIDEO = -5;
const STATUS_TOO_MANY_TAGS = -6;
const STATUS_LINK_GROUP = -7;

export default {
    components: {
        dialogtree: DialogTree
    },

    props: ['appData','userAttribute'],

    data() {
        return {
            scrollOnAction: false,
            existExternalGroup: false,
            tenantList: [],
            editTagList: {},
            orgTagList: {},
            addTagList: {},
            removeTagList: {},
            foundGroupList: [],
            listType: 0,
            condition: "groupId",
            searchString: null,
            disableSave: true
        };
    },

    created: function() {
        this.disableSave = true;
        this.tenantList = [];
        this.tenantList.push(this.appData.tenantList[0]);
        return this.getInfo();
    },

    updated: function() {
        if (this.scrollOnAction) {
            let obj = document.getElementById("selected-user");
            obj.scrollTop = obj.scrollHeight;
            this.scrollOnAction = false;
        }
    },

    methods: {
        getInfo() {
            let self = this;
            self.existExternalGroup = false;
            server.post('/getusertalkgroupinfo', { talkgroupTenantId: this.appData.tenantList[0].tenantId, id: this.userAttribute.id })
                .then((res) => {
                    switch (res.data.status) {
                        case constants.STATUS_SUCCESS:
                        case constants.STATUS_SUCCESS_WITH_ERRORINFO:
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getInfo").replace("{code}",res.data.status));
                            return;
                    }
                    let sortedUserTalkGroup = commonUtil.sortUserTalkGroup(self.appData, res.data.userTalkgroup, constants.OBJECT_TALKGROUP).sortedUserTalkGroup;
                    for (let userTalkgroup of sortedUserTalkGroup) {
                        let key = userTalkgroup.tenantId + '-' + userTalkgroup.talkgroupId;
                        let displayName;
                        if (self.appData.tenantList[0].tenantId == userTalkgroup.tenantId) {
                            displayName = userTalkgroup.talkgroupName
                        } else {
                            displayName = userTalkgroup.talkgroupName + "(" + userTalkgroup.talkgroupTenantName + ")"
                            if (!self.isEnableSave(userTalkgroup.tenantId)) {
                                self.existExternalGroup = true;
                            }
                        }
                        let tagInfo = {
                            id: key ,
                            tenantId: userTalkgroup.tenantId ,
                            userTenantId: userTalkgroup.userTenantId ,
                            talkgroupId: userTalkgroup.talkgroupId ,
                            talkgroupName: userTalkgroup.talkgroupName ,
                            tenantName: userTalkgroup.talkgtoupTenantName ,
                            defaultFlag: userTalkgroup.defaultFlag ,
                            displayName: displayName
                        }
                        Vue.set( self.editTagList , key , tagInfo );
                        Vue.set( self.orgTagList , key , tagInfo );
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getInfo", error);
                });
        },

        findGroup() {
            let param = {tenantId: this.appData.tenantList[0].tenantId}
            if (this.condition == "groupId") {
                param.name = this.searchString;
            } else if (this.condition == "groupName") {
                param.displayName = this.searchString;
            }
            let self = this;
            server.post("/findgroup", param)
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        if (res.data.groupInfo.length == 0) {
                            self.foundGroupList = [];
                            commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found").replace('{object}',commonUtil.getMessageText(self.$i18n,"item_group")));
                            return;
                        }
                    } else {
                        self.foundGroupList = [];
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findGroup").replace("{code}",res.data.status));
                        return;
                    }
                    self.foundGroupList = [];
                    for (let objectInfo of res.data.groupInfo) {
                        let object = { node : { data: null, parent: { data: null} } }
                        object.node.data = {
                            id: self.appData.tenantList[0].tenantId + "-" + objectInfo.id,
                            tenantId: self.appData.tenantList[0].tenantId,
                            type: constants.OBJECT_TALKGROUP,
                            talkgroupId: objectInfo.id,
                            talkgroupName: objectInfo.name ,
                            displayName: objectInfo.displayName,
                            label: objectInfo.name,
                            optionFlag: objectInfo.optionFlag
                        };
                        object.node.parent.data = {id: objectInfo.pid}
                        self.foundGroupList.push(object);
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "findGroup", error);
                    self.foundGroupList = [];
                });
        },

        handleOnSelectNode(data,node) {
            // add talkGroup to user

            if (data.type == constants.OBJECT_TALKGROUP) {
                let key = data.tenantId + "-" + data.id;
                if ((key in this.editTagList)) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    return;
                }
            } else {
                return;
            }

            let self = this;
            let tenantId = data.tenantId;
            let talkgroupId = data.id;
            server.post('/getinfo', {tenantId: tenantId, id: talkgroupId})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let key = tenantId + '-' + talkgroupId;
                        let displayName;
                        if (self.appData.tenantList[0].tenantId == tenantId) {
                            displayName = res.data.name
                        } else {
                            displayName = res.data.name + "(" + tenantName + ")"
                        }
                        let tagInfo = {
                            id: key,
                            tenantId: tenantId,
                            userTenantId: self.appData.tenantList[0].tenantId,
                            talkgroupTenantId: tenantId,
                            talkgroupId: res.data.id ,
                            talkgroupName: res.data.name ,
                            talkgroupOptions: res.data.talkgroupOptions ,
                            tenantName: commonUtil.getTenantName(self.appData, tenantId) ,
                            defaultFlag: false,
                            displayName: displayName
                        };
                        this.addUserTag(tagInfo);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleOnSelectNode").replace("{code}",res.data.status));
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "handleOnSelectNode", error);
                });
        },

        selectTagAll() {
            let addGroupCount = 0;
            for (let groupNode of this.foundGroupList) {
                let tagInfo = groupNode.node.data;
                let condition = this.checkConditionToAdd(tagInfo);
                if (condition === STATUS_SUCCESS) {
                    this.addUserTagInternal(tagInfo)
                    addGroupCount ++;
                } else if (condition === STATUS_TOO_MANY_TAGS) {
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    return;
                }
            }

            if (addGroupCount !== this.foundGroupList.length) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_all_object").replace("{object}",commonUtil.getMessageText(this.$i18n,"item_group")));
            }
        },

        addUserTag(tagInfo) {
            switch(this.checkConditionToAdd(tagInfo)) {
                case STATUS_SUCCESS:
                    this.addUserTagInternal(tagInfo);
                    break;
                case STATUS_ALREADY_EXIST:
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(this.$i18n,"info_group_already_added"));
                    break;
                case STATUS_UNMATCH_SPEECH_TO_TEXT:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_speechText"));
                    break;
                case STATUS_UNMATCH_TRANSLATION:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_translation"));
                    break;
                case STATUS_UNMATCH_MAPTALK:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_mapTalk"));
                    break;
                case STATUS_UNMATCH_VIDEO:
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_group_video"));
                    break;
                case STATUS_TOO_MANY_TAGS:
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    break;
            }
        },

        checkConditionToAdd(tagInfo) {
            if (!(tagInfo.id in this.removeTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= constants.LIMIT_EDIT_TAGS) {
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            if (tagInfo.id in this.editTagList) {
                return STATUS_ALREADY_EXIST;
            }
            if (!this.userAttribute.userOptions.speechToText &&
                (
                    (tagInfo.talkgroupOptions && (tagInfo.talkgroupOptions.speechToTextEngine)) ||
                    ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_SPEECH_TEXT)) !== 0)
                )
            ) {
                return STATUS_UNMATCH_SPEECH_TO_TEXT;
            }
            if (!this.userAttribute.userOptions.translation &&
                (
                    (tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.translationEngine) ||
                    ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_TRANSLATION)) !== 0)
                )
            ) {
                return STATUS_UNMATCH_TRANSLATION;
            }
            if (!this.userAttribute.userOptions.mapTalk &&
                (
                    (tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.mapTalk) ||
                    ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_MAP_TALK)) !== 0)
                )
            ) {
                return STATUS_UNMATCH_MAPTALK;
            }
            if (!this.userAttribute.userOptions.video &&
                (
                    (tagInfo.talkgroupOptions && tagInfo.talkgroupOptions.video) ||
                    ((tagInfo.optionFlag & (1 << constants.TALKGROUP_OPTION_VIDEO)) !== 0)
                )
            ) {
                return STATUS_UNMATCH_VIDEO;
            }
            return STATUS_SUCCESS;
        },

        addUserTagInternal(tagInfo) {
            this.scrollOnAction = true;
            Vue.set(this.editTagList, tagInfo.id , tagInfo);
            Vue.delete(this.removeTagList, tagInfo.id);
            if (!(tagInfo.id in this.orgTagList)) {
                Vue.set(this.addTagList, tagInfo.id, tagInfo);
            }
            this.disableSave = false;
            return true;
        },

        removeAllUserTag() {
            if (this.existExternalGroup) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_all_group_by_link"));
                return;
            }

            for (let tagKey in this.editTagList) {
                let result = this.removeUserTag(this.editTagList[tagKey])
                if (result !== STATUS_SUCCESS) {
                    return;
                }
            }
        },

        removeUserTag(tag) {
            if (!this.isEnableSave(tag.tenantId)) {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_remove_group_by_link"));
                return STATUS_LINK_GROUP;
            }

            if (!(tag.id in this.addTagList)) {
                if (Object.keys(this.addTagList).length + Object.keys(this.removeTagList).length >= constants.LIMIT_EDIT_TAGS) {
                    commonUtil.notifyMessage(this,"Warning", commonUtil.getMessageText(this.$i18n,"error_too_many_tags"));
                    return STATUS_TOO_MANY_TAGS;
                }
            }

            if ((tag.id in this.orgTagList)) {
                Vue.set(this.removeTagList, tag.id, tag);
            }

            Vue.delete(this.addTagList, tag.id);
            Vue.delete(this.editTagList, tag.id)
            this.disableSave = false;

            return STATUS_SUCCESS
        },

        saveUpdatedInfo() {
            this.$emit('save' , { removeTagList: this.removeTagList , addTagList: this.addTagList } );
        },

        isEnableSave(tenantId) {
            if (tenantId === this.appData.tenantList[0].tenantId) {
                return true;
            }
            for (let exportedTenant of this.appData.exportedTenantList) {
                if (exportedTenant.tenantId === tenantId) {
                    return false;
                }
            }
            return false;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}
</style>

